module.exports = __webpack_public_path__ + "img/tan-lih-tyng-v2.2a9b606a.png";